import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

import { IconNames } from '../../../../shared';
import { AlertModalContentComponent } from '../alert-modal-content/alert-modal-content.component';

@Component({
    selector: 'lib-success-modal',
    standalone: true,
    imports: [CommonModule, AlertModalContentComponent],
    templateUrl: './success-message-modal.component.html'
})
export class SuccessMessageModalComponent {
    @Input({ required: true }) title: string = '';
    @Input() message: string = '';
    @Input() confirmButtonLabel: string = 'Got it';
    @Input() icon: IconNames = 'checkmark';
    @Input() iconColor: string = 'var(--ion-color-success)';
    @Input() iconBackgroundColor: string = 'rgba(var(--ion-color-success-rgb), 0.1)';
}
